import React from 'react';
import { TrendingUp, TrendingDown, Crown, ChevronRight, CalendarClock, ImageIcon } from 'lucide-react';
import type { Signal } from '../../features/signals/api/signals';

function dateText(iso?: string): string {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('id-ID', { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jakarta' }) + ' WIB';
  } catch {
    return iso;
  }
}

export function SignalListRow({ s, onClick, testId }: { s: Signal; onClick: () => void; testId?: string }) {
  const isBuy = s.direction === 'buy';
  const hasImage = !!(s.image_url || s.image_link);
  return (
    <button
      data-testid={testId}
      onClick={onClick}
      className="group w-full text-left rounded-xl border border-white/10 bg-white/[0.02] hover:border-cyan-400/40 hover:bg-white/[0.04] transition-colors p-4 flex items-center gap-4"
    >
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-white font-medium tracking-tight">{s.instrument}</span>
          <span className={`flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full ${isBuy ? 'bg-emerald-400/15 text-emerald-300 border border-emerald-400/30' : 'bg-red-400/15 text-red-300 border border-red-400/30'}`}>
            {isBuy ? <TrendingUp className="w-3 h-3" strokeWidth={2} /> : <TrendingDown className="w-3 h-3" strokeWidth={2} />}
            {isBuy ? 'BUY' : 'SELL'}
          </span>
          {s.audience === 'vip' && (
            <span className="flex items-center gap-1 text-[10px] uppercase tracking-wider text-amber-300 bg-amber-400/15 border border-amber-400/30 px-2 py-0.5 rounded-full"><Crown className="w-3 h-3" strokeWidth={1.5} /> VIP</span>
          )}
          {hasImage && <ImageIcon className="w-3.5 h-3.5 text-white/30" strokeWidth={1.5} />}
        </div>
        {s.created_at && (
          <p className="flex items-center gap-1.5 text-[11px] text-white/40 mt-1.5"><CalendarClock className="w-3 h-3 text-cyan-400/70" strokeWidth={1.5} /> {dateText(s.created_at)}</p>
        )}
        <p className="sm:hidden text-[11px] text-white/50 mt-1">
          <span className="text-white/40">E</span> {s.entry_price} · <span className="text-emerald-400/70">TP</span> {s.take_profit ?? '—'} · <span className="text-red-400/70">SL</span> {s.stop_loss ?? '—'}
        </p>
      </div>
      <div className="hidden sm:flex items-center gap-5 text-center shrink-0">
        <div><p className="text-[9px] uppercase tracking-wider text-white/40">Entry</p><p className="text-sm text-white font-medium mt-0.5">{s.entry_price}</p></div>
        <div><p className="text-[9px] uppercase tracking-wider text-emerald-400/70">TP</p><p className="text-sm text-emerald-300 font-medium mt-0.5">{s.take_profit ?? '—'}</p></div>
        <div><p className="text-[9px] uppercase tracking-wider text-red-400/70">SL</p><p className="text-sm text-red-300 font-medium mt-0.5">{s.stop_loss ?? '—'}</p></div>
      </div>
      <ChevronRight className="w-5 h-5 text-white/30 group-hover:text-cyan-400 transition-colors shrink-0" strokeWidth={1.5} />
    </button>
  );
}
